import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { getUser } from '../store/user';

// const createStripeAccount = httpsCallable(functions, 'createStripeAccount')
// const editStripeAccount = httpsCallable(functions, 'editStripeAccount')
const createStripeAccount = httpsCallable(functions, 'createStripeAccount');
const editStripeAccount = httpsCallable(functions, 'editStripeAccount');

// Set up account.
// When included on a page, will trigger a redirect.
export default function useHostPayout() {
  const user = useSelector(getUser);

  useEffect(() => {
    if (!user) return;

    const { stripeAccountId } = user;
    const return_url = window.location.origin + '/';
    const refresh_url = window.location.origin + '/host/stripe/';
    // Billing B2.2: the server sets live or test money, not the browser.
    const props = {
      refresh_url,
      return_url
    };

    (stripeAccountId
      ? editStripeAccount({
          stripeAccountId,
          ...props
        })
      : createStripeAccount(props)
    ).then(({ data: url }) => {
      if (url) {
        window.location.href = url;
      }
    });
  }, []);
}
